import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";

type ThemeProp = {
    children: JSX.Element
}

export enum MedidasLayOut {
    WIDTH_SIDEBAR = "7vw",
    WIDTH_SIDEBAR_PHONE = "12vw",
    TOP_SIDEBAR = "10vh",
    LEFT_SIDEBAR = "0.5vw",
}

export enum PalettePreferencia {
    PREFERENCIA_1 = "#00B5FF",
    PREFERENCIA_2 = "#0098FF",
    PREFERENCIA_3 = "#0080FF",
}

export enum PaletteGrupos {
    GRUPO_1 = "#5BB32D",
    GRUPO_2 = "#0090A4",
    GRUPO_3 = "#4844A4",
    GRUPO_4 = "#FF8B00",
    ERROR = "#00B5FF"
}

export enum themePalette {
    BG = "#12181b",
    BGWHITE = "#FFFFFF",
    BGTRANSPARENT = "transparent",
    BG_SIDEBAR = "#EAEBF0",
    COLOR_SIDEBAR_ICON = "#002755",
    NAVCOLOR = "#243165",
    FOOTERCOLOR = "#A3A3A3",
    BUTTONOK = "#6CC427",
    BUTTONYELLOW = "#EEC427",
    LIGHTBLUE = "#35B5E5",
    CHAMBRAY = "#114B8A",
    GAINSBORO = "#DCDCDC",
    FONT_GLOBAL = "'Roboto', sans-serif",
    FONT_TITLE = "'Roboto', sans-serif",
    FONT_COLOR_LIGHTBLUE = '#2BC1FF',
    COLOR_INSCRIPCION = '#EEC427',
    COLOR_POSTULACION = '#6CC427',
    COLOR_ACEPTACION = '#28BED1',
    COLOR_CONSULTA = '#FF938C',
    COLOR_FONT_FOOTER = '#7C9EDE',
}

export enum themePaletteArea {
    AREA_ING_CIENCIA_1 = '#00B5FF',
    AREA_ING_CIENCIA_2 = '#425CC7',
    AREA_ING_CIENCIA_3 = '#472E87',
    AREA_CIENCIA_BIO = '#67A200',
    AREA_EDU_COMERCIAL = '#CDA315',
    AREA_ARTE = '#BF309B',
    AREA_HUMANIDADES = '#DEAE6D',
    AREA_SERVICIOS = '#FFC94B',
    AREA_SALUD = '#00BE7F',
}

const theme = createTheme({
    palette: {
        mode: "light",
        background: {
            default: themePalette.BGWHITE,
        },
        primary: {
            main: themePalette.LIGHTBLUE,
        },
    },
    typography: {
        fontFamily: themePalette.FONT_GLOBAL,
    },
    components: {
        MuiButton: {
            defaultProps: {
                style: {
                    textTransform: "none",
                    boxShadow: "none",
                    borderRadius: "2em",
                    color: themePalette.BG,
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                InputLabelProps: {
                    style: {
                        color: themePalette.CHAMBRAY, // Color específico para el texto del label
                        fontWeight: 'bold', // Negrita
                    },
                },
            }
        },
        MuiInputLabel: {
            defaultProps: {
                style: {
                    color: themePalette.CHAMBRAY, // Color específico para el texto del label
                    fontWeight: 'bold', // Negrita
                },
            }
        },
        MuiFormControlLabel: {
            defaultProps: {
                style: {
                    color: themePalette.CHAMBRAY, // Color específico para el texto del label
                    fontWeight: 'bold', // Negrita
                },
            }
        },
        MuiTypography: {
            defaultProps: {
                style: {
                    fontWeight: 'bold',
                }
            }
        }
    }
})

export const ThemeConfig: React.FC<ThemeProp> = ({ children }) => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    );
}